import { render, staticRenderFns } from "./habitFormFrequencyPicker.vue?vue&type=template&id=63577683&scoped=true"
import script from "./habitFormFrequencyPicker.vue?vue&type=script&lang=js"
export * from "./habitFormFrequencyPicker.vue?vue&type=script&lang=js"
import style0 from "./habitFormFrequencyPicker.vue?vue&type=style&index=0&id=63577683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63577683",
  null
  
)

export default component.exports